import React from 'react';

import classes from './DiscountDescription.module.scss';
import { getPriceView } from '../../../../shared/utils/stringUtils';

export type DiscountDescriptionProps = {
  discountPercent: number | null | undefined;
  oldPrice: number | null | undefined;
};

const DiscountDescription = ({ discountPercent, oldPrice }: DiscountDescriptionProps) => {
  if (!oldPrice || !discountPercent) {
    return null;
  }

  return (
    <span>
      (<span className={classes.oldPrice}>{getPriceView(oldPrice)}</span>
      <span> - {discountPercent}% discount</span>)
    </span>
  );
};

export { DiscountDescription };
